// extracted by mini-css-extract-plugin
export var active = "tabs-module--active--DIa-L";
export var btn_auth_container = "tabs-module--btn_auth_container--+YPV8";
export var choose_button = "tabs-module--choose_button--zSSih";
export var mobile_tabs = "tabs-module--mobile_tabs--rxSZN";
export var mobile_tabs_container = "tabs-module--mobile_tabs_container--BXw2r";
export var red = "tabs-module--red--R2SXx";
export var tabs_container = "tabs-module--tabs_container--oGJfz";